// 🪟 portedBus — tiny module-level bridge for ported-space window cards
// (IMAGINE_REACTIVE_WINDOWS_SPEC §2 W3/idea 6). SpaceCommandAction sits deep
// under memoized renderers whose prop identity must stay stable (perf 08-13:
// the feed memo only holds because feedDerivation keeps identities stable) —
// so the window card reads gameId/creds/adds from here instead of new props.
// GameStepPage owns the writes (one effect); everything else only reads.
// null everywhere outside ported spaces.
export const portedBus = {
  gameId: null,
  humanPlayerId: null,
  adds: null,   // { [action_id]: [{ line, at }] } from the status payload
  poke: null,   // (actionId, kind, extra) => void
  // 🪟🏮 true on ported DESKTOP once the Hearthside Rail collects windows into
  // its own stack — the inline feed render then returns null so a window has
  // ONE home (the rail), never two close/ack surfaces. Mobile stays inline.
  suppressInlineWindows: false,
};
